import http, { httpGet } from '@/utils/http';

export default {
	// V2 API (主要使用)
	list: data => {
		return http({ url: '/api/admin/v2/delivery/list', data }).then(r => r);
	},
	getProductDetails: data => {
		return http({ url: '/api/admin/v2/delivery/getProductDetails', data }).then(r => r);
	},
	getProductDetailsList: data => {
		return http({ url: '/api/admin/v2/delivery/getProductDetailsList', data }).then(r => r);
	},
	exportDetails: data => {
		return http({ url: '/api/admin/v2/delivery/exportDetails', data }).then(r => r);
	},
    printDelivery: data => {
        return http({ url: '/api/admin/v2/delivery/printDelivery', data, tip: true }).then(r => r);
    },
	updateDeliveryCount: data => {
		return http({ url: '/api/admin/v2/delivery/updateDeliveryCount', data, tip: true }).then(r => r);
	},
	completeDelivery: data => {
		return http({ url: '/api/admin/v2/delivery/completeDelivery', data, tip: true }).then(r => r);
	},
	completeDeliveryBatch: data => {
		return http({ url: '/api/admin/v2/delivery/completeDeliveryBatch', data, tip: true }).then(r => r);
	},
	generateDeliveryWithSync: data => {
		return http({ url: '/api/admin/v2/delivery/generateDeliveryWithSync', data }).then(r => r);
	},
	getGenerateProgressV2: data => {
		return http({ url: '/api/admin/v2/delivery/getGenerateProgress', data }).then(r => r);
	},

	// V3 API
	generateDelivery: data => {
		return http({ url: '/api/admin/v3/delivery/generateDelivery', data, tip: true, loading: true }).then(r => r);
	},
	// V3 异步生成配送单（带进度条）
	generateDeliveryAsync: data => {
		return http({ url: '/api/admin/v3/delivery/generateDeliveryAsync', data }).then(r => r);
	},
	// V3 异步导出配送单明细（带进度条）
	exportDeliveryDetailsAsync: data => {
		return http({ url: '/api/admin/v3/delivery/exportDeliveryDetailsAsync', data }).then(r => r);
	},

	// V1 API (保留兼容)
	previewDeliveryWord: data => {
		return http({ url: '/api/admin/v1/delivery/previewDeliveryWord', data}).then(r => r);
	},
	saveDeliveryWord: data => {
		return http({ url: '/api/admin/v1/delivery/saveDeliveryWord', data, tip: true }).then(r => r);
	},
	createDeliveryWordFromSortingWords: data => {
		return http({ url: '/api/admin/v1/delivery/createDeliveryWordFromSortingWords', data, tip: true }).then(r => r);
	},
	previewDeliveryWordFromSortingWords: data => {
		return http({ url: '/api/admin/v1/delivery/previewDeliveryWordFromSortingWords', data }).then(r => r);
	},
	generateDeliveryWordWithSync: data => {
		return http({ url: '/api/admin/v1/delivery/generateDeliveryWordWithSync', data }).then(r => r);
	},
	getGenerateProgress: (taskId) => {
		return httpGet({ 
			url: '/api/admin/v1/delivery/getGenerateProgress', 
			params: { task_id: taskId } 
		}).then(r => r);
	},
};

